import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { MeetingResponse, MeetingsParams } from "@/api/types"

export function meetingsOptions(
	params: MeetingsParams = {},
	{ enabled = true }: { enabled?: boolean } = {},
) {
	return queryOptions({
		queryKey: ["meetings", params],
		queryFn: () =>
			GET("/api/v1/companies/meetings", {
				params: { query: params },
			}),
		placeholderData: keepPreviousData,
		enabled: !!params.companyId && enabled,
	})
}

export function useMeetings(
	params: MeetingsParams & { enabled?: boolean } = {},
) {
	const { enabled, ...queryParams } = params
	return useQuery(meetingsOptions(queryParams, { enabled }))
}

export function useMeeting(
	meetingId: string | undefined,
	options: {
		placeholderData?: MeetingResponse
		enabled?: boolean
	} = {},
) {
	const { placeholderData, enabled = true } = options
	return useQuery({
		queryKey: ["meeting", meetingId],
		queryFn: () => {
			if (!meetingId) throw new Error("meetingId is required")
			return GET("/api/v1/companies/meetings/{meeting_id}", {
				params: { path: { meeting_id: meetingId } },
			})
		},
		enabled: !!meetingId && enabled,
		placeholderData,
	})
}
